module.exports = __webpack_public_path__ + "band_10_son.cb52b209.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_10_son.png
// module id = FZqt
// module chunks = 0